import { Component, OnInit } from "@angular/core";
import { Input } from "@angular/core";

@Component({
    selector: "dodo-icon",
    templateUrl: "./icon.component.html",
    styleUrls: ["./icon.component.scss"],
    standalone: false
})
export class IconComponent implements OnInit {
	@Input() settings: any;

	constructor() {}

	ngOnInit() {}
}
